<div id="overlay-loader" *ngIf="loadingIcon">
  <div class="k-icon k-i-loading outer"></div>
</div>
